import { cn } from "@do/ui/lib/utils";

export const HeaderSettingsSection = ({
  id,
  children,
  title,
  description,
  icon: Icon,
}: {
  id: string;
  children: React.ReactNode;
  title: string;
  description: string;
  icon: React.ElementType;
} & React.ComponentPropsWithoutRef<"div">) => {
  return (
    <div
      id={`header-settings-dialog-content-section-${id}`}
      className="flex flex-col p-(--header-settings-dialog-padding) gap-3"
    >
      <div
        id={`header-settings-dialog-content-section-${id}-header`}
        className="flex flex-col gap-1.5"
      >
        <div className="flex items-center gap-2">
          <Icon
            aria-hidden="true"
            id={`header-settings-dialog-content-section-${id}-icon`}
            className={cn(
              "size-(--header-settings-dialog-content-section-icon-size)",
              "text-(--header-settings-dialog-content-section-icon-color)/(--header-settings-dialog-content-section-icon-color-opacity)"
            )}
          />
          <h3
            id={`header-settings-dialog-content-section-${id}-title`}
            className={cn(
              "font-(--header-settings-dialog-content-section-title-font-weight)! font-(family-name:--header-settings-dialog-content-section-title-font-family)",
              "text-(--header-settings-dialog-content-section-title-color)/(--header-settings-dialog-content-section-title-color-opacity) text-(length:--header-settings-dialog-content-section-title-font-size)",
              "leading-(--header-settings-dialog-content-section-title-line-height)"
            )}
          >
            {title}
          </h3>
        </div>

        <p
          id={`header-settings-dialog-content-section-${id}-description`}
          className={cn(
            "text-(--header-settings-dialog-content-section-description-color)/(--header-settings-dialog-content-section-description-color-opacity) text-(length:--header-settings-dialog-content-section-description-font-size)",
            "font-(--header-settings-dialog-content-section-description-font-weight)! font-(family-name:--header-settings-dialog-content-section-description-font-family)",
            "leading-(--header-settings-dialog-content-section-description-line-height)"
          )}
        >
          {description}
        </p>
      </div>

      <div id={`header-settings-dialog-content-section-${id}-content`}>{children}</div>
    </div>
  );
};
